import styled, { css } from 'styled-components';

import { NextImageWithLoader } from '@/components/NextImageWithLoader';

import { Typography } from '../../../../Typography';

export const Wrapper = styled.div<{ $isCurrentLink: boolean }>`
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  text-decoration: none;
  position: relative;
  border-radius: 100px;
  & > img {
    width: 16px;
    height: 16px;
    position: relative;
  }

  ${({ $isCurrentLink, theme }) => css`
    padding: 3px;
    border: 1px solid ${theme.colors.defaultAdd4};
    &:hover {
      background-color: ${theme.colors.primaryBlue};
      color: ${theme.colors.white};
      border: 1px solid ${theme.colors.primaryBlue};
      & > div {
        background-color: ${theme.colors.primary};
      }
    }
    color: ${theme.colors.secondary};

    ${$isCurrentLink &&
    css`
      background-color: ${theme.colors.primaryBlue};
      color: ${theme.colors.white};
      border: 1px solid ${theme.colors.primaryBlue};
      & > div {
        background-color: ${theme.colors.primary};
      }
    `}
    @media (max-width: 1280px) {
      &:last-child {
        margin-right: 0;
      }
    }

    ${theme.media.md.down} {
      &:last-child {
        margin-right: 0;
      }
    }
  `}
`;
export const NavQuickImgBox = styled.div`
  border-radius: 100%;
  overflow: hidden;
  width: 26px;
  height: 26px;
  min-width: 16px;
  background-color: #e1e1e1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
export const Label = styled(Typography)`
  text-transform: uppercase;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 5px -2px;
  align-items: center;
  cursor: pointer;

  ${({ theme }) => css`
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.fontSizes.p1};
    line-height: 1;
    ${theme.media.md.up} {
      font-size: ${theme.fontSizes.p1};
    }
  `}
`;

export const NavQuickImg = styled(NextImageWithLoader)`
  position: relative;
  border-radius: 100%;
  overflow: hidden;
  width: 16px;
  height: 16px;
  min-width: 16px;
  ${({ theme }) => theme.media.md.down} {
    margin-bottom: -2px;
  }
`;
